import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AudioServiceService } from '../audio-service.service';
import { GamePlayService } from '../game-play/gamePlayService.service';
import { routeService } from '../route-service.service';
import { TimerService } from '../timer/timerService.service';
import { TriviaGameService } from './triviaGameService.service';

@Component({
  selector: 'app-trivia-game',
  templateUrl: './trivia-game.component.html',
  styleUrls: ['./trivia-game.component.scss']
})
export class TriviaGameComponent implements OnInit, OnDestroy {

  version: string;
  game;
  halfHelper = true;
  replaceHelper = true;
  gameInfoOpen = true;
  chooseLane = false;
  replaceQuestion = false;
  question;
  lettersArray = [];
  answerArray = [];
  randoms = [];
  crossroad = null;
  questionSub: Subscription;
  randomsSub: Subscription;
  crossSub: Subscription;

  constructor(private audioService: AudioServiceService, private timerService: TimerService, public routeService: routeService, private route: ActivatedRoute, private triviaGameService: TriviaGameService, private gamePlayService: GamePlayService, private router: Router) { }

  ngOnInit(): void {
    this.game = this.gamePlayService.game;

    this.questionSub = this.triviaGameService.currentQuestion.subscribe(question => {
      this.question = question;
      if (question != null && question.type == 'complete') {
        this.lettersArray = Array(question.answer.length).fill(0);
        this.answerArray = Array(question.answer.length).fill(0);
      }
    });
    this.randomsSub = this.triviaGameService.randoms.subscribe(randoms => {
      this.randoms = randoms;
    });
    this.crossSub = this.triviaGameService.crossroad.subscribe(crossroad => {

      if (crossroad) {
        this.audioService.playAudio('changeStation');
        let stations = crossroad.split('-');
        this.crossroad = crossroad;
        this.chooseLane = true;
        let classColor;
        stations.forEach(station => {
          switch (station) {
            case 'pink':
              classColor = 'cls-3';
              break;
            case 'green':
              classColor = 'cls-7';
              break;
            case 'orange':
              classColor = 'cls-8';
              break;
            case 'red':
              classColor = 'cls-9';
              break;

            default:
              break;
          }
          for (let i = 0; i < 20; i++) {
            let lane = document.getElementById(station + '-' + i + '-' + (i + 1));
            if (lane && lane.classList.contains('cls-11')) {
              lane.classList.add(classColor);
              lane.classList.add('classColor');
              lane.classList.remove('cls-11');
            }
          }
        });
      }
    });
    // document.body.style.backgroundImage = "url('../../assets/images/backgrounds/night-background.png')";
    // this.version = this.route.snapshot.params['id'];
    // if (this.version == 'mitanim' || this.version == 'nosaim') {
    //   this.game.name += this.version;
    // } else {
    //   this.game.name += 'mitanim';
    // }
  }

  closeInfo() {
    this.gameInfoOpen = false;
    setTimeout(() => {
      document.getElementById('pink-0').setAttribute('class', 'cls-3');
      this.makePulse('pink-0');
    }, 100);
    setTimeout(() => {
      this.triviaGameService.getRandomQuestion();
    }, 3000);
  }

  changeLane(lane) {
    this.triviaGameService.lastLane = this.triviaGameService.lane;
    this.triviaGameService.lane = lane;
    let lanes = document.getElementsByClassName('classColor');
    for (let i = lanes.length - 1; i >= 0; i--) {
      lanes[i].classList.add('cls-11');
      lanes[i].classList.remove('classColor');
    }
    switch (this.crossroad) {
      case 'pink-green':
        if (lane == 'green') {
          this.triviaGameService.laneProgress = 0;
        }
        break;
      case 'pink-orange':
        if (lane == 'orange') {
          this.triviaGameService.laneProgress = 0;
        }
        break;
      case 'green-orange':
        if (lane == 'green') {
          this.triviaGameService.laneProgress = 4;
        } else if (lane == 'orange') {
          this.triviaGameService.laneProgress = 3;
        }
        break;
      case 'pink-green-red':
        if (lane == 'pink') {
          this.triviaGameService.laneProgress = 12;
        } else if (lane == 'green') {
          this.triviaGameService.laneProgress = 7;
        } else if (lane == 'red') {
          this.triviaGameService.laneProgress = 0;
        }
        break;
      case 'orange-red':
        if (lane == 'orange') {
          this.triviaGameService.laneProgress = 8;
        } else if (lane == 'red') {
          this.triviaGameService.laneProgress = 3;
        }
        break;

      default:
        break;
    }
    this.triviaGameService.getRandomQuestion();
    this.chooseLane = false;
  }

  newQuestion() {
    this.chooseLane = true;
  }

  getQuestion(diff: number) {
    this.chooseLane = false;
  }

  onHelp(help) {
    if (this.question != null) {
      switch (this.question.type) {
        case 'trivia':
          switch (help) {
            case "half":
              this.halfHelper = false;
              let randoms = [];
              while (randoms.length < 2) {
                let random = Math.floor(Math.random() * 3 + 1);
                for (let i = 0; i < randoms.length; i++) {
                  if (randoms[i] == random) {
                    random = Math.floor(Math.random() * 3 + 1);
                    i = -1;
                  }
                }
                randoms.push(random);
                if (randoms.length == 2) {
                  randoms.forEach(random => {
                    this.question.answers[random] = "";
                  });
                }
              }
              break;
            case "replace":
              this.replaceHelper = false;
              this.replaceQuestion = true;
              this.question = null;
              setTimeout(() => {
                this.replaceQuestion = false;
                this.triviaGameService.getRandomQuestion();
                let cont = document.getElementById('quesiton-cont');
                cont.classList.add('change-question');
              }, 10);
              break;
            default:
              break;
          }
          break;
        case 'complete':
          switch (help) {
            case "half":
              this.halfHelper = false;
              const randoms = this.triviaGameService.randomNums(this.question.answer.length, 2, this.question.startWith);
              randoms.forEach(random => {
                this.question.startWith.push(random);
                const input: any = document.getElementById(random);
                // input.setAttribute('value', this.question.answer[random]);
                input.value = this.question.answer[random];
                input.setAttribute("readonly", 'true');
                this.answerArray[random] = this.question.answer[random];
              });
              break;
            case "replace":
              this.replaceHelper = false;
              this.replaceQuestion = true;
              this.question = null;
              setTimeout(() => {
                this.replaceQuestion = false;
                this.triviaGameService.getRandomQuestion();
                let cont = document.getElementById('quesiton-cont');
                cont.classList.add('change-question');

              }, 10);
              break;
            default:
              break;
          }
          break;

        default:
          break;
      }
    }
  }

  onType(ev) {
    const currentContainer = ev.target.id;
    const letter = ev.target.value;
    this.answerArray[currentContainer] = letter;

    if ((ev.key == 'Backspace' || ev.key == 'Delete')) {
      if (ev.target.value == '') {
        let prevContainer = parseInt(currentContainer) - 1;
        for (let i = 0; i < this.question.startWith.length; i++) {
          if (this.question.startWith[i] == prevContainer) {
            prevContainer--;
            i = -1;
          }
        }
        if (prevContainer >= 0) {
          document.getElementById(prevContainer.toString()).focus();
        }
      }
    } else if (ev.target.value != '') {
      let nextContainer = parseInt(currentContainer) + 1;
      for (let i = 0; i < this.question.startWith.length; i++) {
        if (this.question.startWith[i] == nextContainer) {
          nextContainer++;
          i = -1;
        }
      }
      if (nextContainer < this.question.answer.length) {
        document.getElementById(nextContainer.toString()).focus();
      }
    }
  }

  makePulse(stationID) {
    let oldPulse = document.getElementById('pulseID');
    if (oldPulse) {
      oldPulse.classList.remove('pulse-in');
      oldPulse.classList.add('pulse-out');
      setTimeout(() => {
        oldPulse.remove();
      }, 3000);
    }
    let station = document.getElementById(stationID);
    let rect = station.getBoundingClientRect();
    console.log(rect);

    let div = document.createElement('DIV');
    div.id = 'pulseID';
    div.classList.add('pulse');
    div.classList.add('pulse-in');
    div.style.left = rect.left + 'px';
    div.style.top = rect.top + 'px';
    div.style.height = rect.height + 'px';
    div.style.width = rect.width + 'px';

    let color;
    switch (this.triviaGameService.lane) {
      case 'pink':
        color = '#ff55cf'
        break;
      case 'green':
        color = '#52ff98'
        break;
      case 'orange':
        color = '#ffa750'
        break;
      case 'red':
        color = '#c1272d'
        break;
      default:
        break;
    }

    for (let i = 1; i < 4; i++) {
      let span = document.createElement('span');
      span.setAttribute('style', '--i:' + i);
      // span.style.left = rect.x + 'px';
      // span.style.top = rect.y + 'px';
      span.style.backgroundColor = color;
      span.style.height = rect.height + 'px';
      span.style.width = rect.width + 'px';
      div.appendChild(span);
    }


    document.body.appendChild(div);
  }

  onTriviaAnswer(event) {
    let id = event.target.id;
    if (!event.target.id) {
      id = event.target.parentElement.id;
    }
    let answer: any = document.getElementById(id.toString());
    answer.disabled = true;
    if (id == 0) {
      answer.classList.add('right-answer');
      document.getElementById("result" + id.toString()).classList.add('result-correct');
      document.getElementById("result" + id.toString()).classList.add('result-show');
      this.audioService.playAudio('correctTrivia');
      setTimeout(() => {
        this.moveProgress();
      }, 1000);
    } else {
      answer.classList.add('wrong-answer');
      document.getElementById("result" + id.toString()).classList.add('result-error');
      document.getElementById("result" + id.toString()).classList.add('result-show');

      this.audioService.playAudio('incorrect');
      this.triviaGameService.wrongAnswer();
    }
  }

  onCompleteAnswer() {
    let word = "";
    for (let i = 0; i < this.answerArray.length; i++) {
      word += this.answerArray[i];
    }
    if (word == this.question.answer) {
      this.audioService.playAudio('correctTrivia');
      this.moveProgress();
    } else {
      if (this.gamePlayService.lifes.getValue() > 1) {
        let flash = document.createElement('DIV');
        flash.classList.add('flash');
        document.body.appendChild(flash);
        setTimeout(() => {
          flash.remove();
        }, 200);
      }
      this.audioService.playAudio('incorrect');
      this.triviaGameService.wrongAnswer();
    }
  }

  moveProgress() {
    let stationID = this.crossroad ? this.crossroad : (this.triviaGameService.lane + '-' + this.triviaGameService.laneProgress);
    let laneID = this.triviaGameService.lane + '-' + (this.triviaGameService.laneProgress - 1) + '-' + this.triviaGameService.laneProgress;

    let stationColorClass;
    if (this.triviaGameService.lane == 'pink') {
      stationColorClass = 'cls-3';
    } else if (this.triviaGameService.lane == 'green') {
      stationColorClass = 'cls-7';
    } else if (this.triviaGameService.lane == 'orange') {
      stationColorClass = 'cls-8';
    } else if (this.triviaGameService.lane == 'red') {
      stationColorClass = 'cls-9';
    }

    let laneColorClass = stationColorClass;
    if (this.crossroad) {
      switch (this.crossroad) {
        case 'pink-green':
          laneID = 'pink-4-5';
          laneColorClass = 'cls-3';
          break;
        case 'pink-orange':
          laneID = 'pink-5-6';
          laneColorClass = 'cls-3';
          break;
        case 'green-orange':
          if (this.triviaGameService.lastLane == 'green') {
            laneID = 'green-3-4';
            laneColorClass = 'cls-7';
          } else if (this.triviaGameService.lastLane == 'orange') {
            laneID = 'orange-2-3';
            laneColorClass = 'cls-8';
          }
          break;
        case 'pink-green-red':
          if (this.triviaGameService.lastLane == 'pink') {
            laneID = 'pink-11-12';
            laneColorClass = 'cls-3';
          } else if (this.triviaGameService.lastLane == 'green') {
            laneID = 'green-6-7';
            laneColorClass = 'cls-7';
          }
          break;
        case 'orange-red':
          if (this.triviaGameService.lastLane == 'orange') {
            laneID = 'orange-7-8';
            laneColorClass = 'cls-8';
          } else if (this.triviaGameService.lastLane == 'red') {
            laneID = 'red-2-3';
            laneColorClass = 'cls-9';
          }
          break;
        default:
          break;
      }
    }

    let station = document.getElementById(stationID);
    let lane = document.getElementById(laneID);
    console.log(stationID);

    console.log(station);


    this.makePulse(stationID);

    station.setAttribute('class', stationColorClass);
    lane.setAttribute('class', laneColorClass);
    this.crossroad = null;
    this.triviaGameService.rightAnswer();
  }

  onNewWord() {
    this.question.startWith.forEach(letterPos => {
      const input: any = document.getElementById(letterPos.toString());
      input.value = this.question.answer[letterPos];
      // input.setAttribute('value', this.question.answer[letterPos]);
      input.setAttribute("readonly", 'true');
      this.answerArray[letterPos] = this.question.answer[letterPos];
    });
  }

  ngOnDestroy() {
    this.questionSub.unsubscribe();
    this.randomsSub.unsubscribe();
    this.crossSub.unsubscribe();
  }
}
